import {TPlatform} from '../../../hooks/usePlatform'

type TPlatformIcon = 'googlePlay' | 'appStore'
type TPlatformToIconMap = Map<TPlatform, TPlatformIcon>

export const platformToIconMap: TPlatformToIconMap = new Map([
  ['android', 'googlePlay'],
  ['huawei', 'googlePlay'],
  ['other', 'googlePlay'],
  ['apple', 'appStore'],
])

type TPlatformInvertedIcon = 'googlePlayBlack' | 'appStoreBlack'
type TPlatformToInvertedIconMap = Map<TPlatform, TPlatformInvertedIcon>

export const platformToInvertedIconMap: TPlatformToInvertedIconMap = new Map([
  ['android', 'googlePlayBlack'],
  ['huawei', 'googlePlayBlack'],
  ['other', 'googlePlayBlack'],
  ['apple', 'appStoreBlack'],
])
